var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data_loss_prevention_FILL0_wght300_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.4178 20.4178C21.1258 20.7124 20.65 20.7134 20.3567 20.4202L15.9096 15.973C15.2006 16.5384 14.4448 16.9759 13.6423 17.2855C12.8397 17.5951 11.959 17.75 11 17.75C8.83716 17.75 7.00479 16.999 5.50287 15.4971C4.00096 13.9952 3.25 12.1628 3.25 9.99998C3.25 7.83716 4.00096 6.00479 5.50287 4.50288C7.00479 3.00096 8.83716 2.25 11 2.25C13.1628 2.25 14.9952 3.00096 16.4971 4.50288C17.999 6.00479 18.75 7.83716 18.75 9.99998C18.75 10.959 18.5951 11.8413 18.2855 12.6471C17.9759 13.4529 17.5384 14.2102 16.973 14.9192L21.4154 19.3615C21.7068 19.6529 21.7078 20.125 21.4178 20.4178ZM11 16.25C12.7307 16.25 14.2051 15.641 15.4231 14.4231C16.641 13.2051 17.25 11.7307 17.25 9.99998C17.25 8.26921 16.641 6.79484 15.4231 5.57688C14.2051 4.35893 12.7307 3.74995 11 3.74995C9.26921 3.74995 7.79484 4.35893 6.57687 5.57688C5.35892 6.79484 4.74995 8.26921 4.74995 9.99998C4.74995 11.7307 5.35892 13.2051 6.57687 14.4231C7.79484 15.641 9.26921 16.25 11 16.25Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.e3ca826a716960ced6b946b86364161f.svg";
export { ForwardRef as ReactComponent };